import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";

import { TranslatePipe } from "#modules/shared/i18n";

export interface ExternalNavigationInput {
  url: string;
  name: string;
}

@Component({
  selector: "app-external-navigation",
  imports: [MatDialogModule, TranslatePipe, MatButtonModule, MatIconModule],
  templateUrl: "./external-navigation.component.html",
  styleUrl: "./external-navigation.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExternalNavigationComponent {
  readonly data = inject<ExternalNavigationInput>(MAT_DIALOG_DATA);
}
